module.exports = __webpack_public_path__ + "static/media/AF.17cf817c.svg";